import type { TFunction } from 'i18next'

import type { Load } from './api'

/**
 * A load's equipment as the book and the form say it: DAT's code as printed, then its
 * reading — the type the code starts with, and the alternative the broker also takes
 * ("VR · Dry van or reefer", Hugo's reading of the second letter on TRKC-30).
 */
export function equipmentLabel(
  load: Pick<Load, 'equipment' | 'alternativeEquipment' | 'datEquipmentCode'>,
  t: TFunction,
): string {
  const own = t(`carriers.types.${load.equipment}`)
  const reading =
    load.alternativeEquipment === null
      ? own
      : t('loads.equipmentOr', { own, alternative: t(`carriers.types.${load.alternativeEquipment}`) })

  return load.datEquipmentCode === null ? reading : `${load.datEquipmentCode} · ${reading}`
}
